module.exports = __webpack_public_path__ + "static/media/business.a252ec07.jpg";